import React, { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';
import Hero from './components/Hero';
import ProductShowcase from './components/ProductShowcase';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import CommercialBenefits from './components/CommercialBenefits';
import MobileApp from './components/MobileApp';
import TVScreen from './components/TVScreen';
import BusinessTypes from './components/BusinessTypes';
import HybridModel from './components/HybridModel';
import MultiLocation from './components/MultiLocation';
import Prizes from './components/Prizes';
import DataRemarketing from './components/DataRemarketing';
import ROI from './components/ROI';
import Implementation from './components/Implementation';
import UseCases from './components/UseCases';
import Plans from './components/Plans';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import DemoModal from './components/DemoModal';
import './App.css';

import ScrollToTop from './components/ScrollToTop';
import StickyBanner from './components/StickyBanner';

function App() {
  const [showModal, setShowModal] = useState(false);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-[#1F2833]" data-testid="app-root">
          <Header onDemoClick={() => setShowModal(true)} />
          <main>
            <Hero onDemoClick={() => setShowModal(true)} />
            <ProductShowcase />
            <Features />
            <HowItWorks onDemoClick={() => setShowModal(true)} />
            <CommercialBenefits />
            <MobileApp />
            <TVScreen onDemoClick={() => setShowModal(true)} />
            <BusinessTypes />
            <HybridModel />
            <MultiLocation />
            <Prizes />
            <DataRemarketing />
            <ROI />
            <Implementation onDemoClick={() => setShowModal(true)} />
            <UseCases />
            <Plans onDemoClick={() => setShowModal(true)} />
            <FAQ />
            <FinalCTA onDemoClick={() => setShowModal(true)} />
          </main>
          <Footer onDemoClick={() => setShowModal(true)} />
          <StickyBanner onDemoClick={() => setShowModal(true)} />
          <ScrollToTop />
          {showModal && <DemoModal onClose={() => setShowModal(false)} />}
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
